module.exports = __webpack_public_path__ + "img/p1-1-1.8ca80d5e.png";